import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "../../Api/constants";

export const categoryService = createApi({
    reducerPath: "categoryService",
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL + "/api/",
        prepareHeaders: (headers, { getState }) => {
            const reducers = getState();
            const token = reducers?.authReducer?.adminToken;
            headers.set("authorization", token ? `Bearer ${token}` : "");
            return headers;
          },
        }),
    tagTypes: ["Categories"],  // Tag type for cache invalidation
    endpoints: (builder) => ({
        fetchCategories: builder.query({
            query: () => "admin/categories",
            providesTags: (result) =>
                result ? [{ type: "Categories", id: "LIST" }] : [],
        }),

        addCategory: builder.mutation({
            query: (formData) => ({
                url: "admin/categories",
                method: "POST",
                body: formData,
            }),
            invalidatesTags: [{ type: "Categories", id: "LIST" }],
        }),

        editCategory: builder.mutation({
            query: ({ formData }) => ({
                url: `admin/edit-category`, // PUT request for editing category
                method: "POST",
                body: formData,
            }),
            invalidatesTags: [{ type: "Categories", id: "LIST" }],
        }),

        deleteCategory: builder.mutation({
            query: (id) => ({
              url: `admin/categories/${id}`, // Delete endpoint
              method: "DELETE",
            }),
            invalidatesTags: [{ type: "Categories", id: "LIST" }], // Invalidate customer list to refresh data
          }),


    }),
});

export const { useFetchCategoriesQuery, useAddCategoryMutation, useEditCategoryMutation,useDeleteCategoryMutation } = categoryService;
